import loader from '../moduleLoader.js';

class Parallax {
    constructor(container) {
        this.container = container;
        this.resizeTimeout = null;
        this.background = null;
        this.overlay = null;
        this.containerFromTop = null;
        this.handleScroll = this.handleScroll.bind(this);
        this.observe = this.observe.bind(this);
        this.maxYShift = 150;
    }
    init() {
        // if(this.isInViewPort()) {
        //     this.container.classList.add('parallax--in-viewport');
        // }
        this.background = this.container.querySelector('.parallax__background > div');
        this.overlay = this.container.querySelector('.parallax__overlay');   
        this.containerFromTop = this.container.offsetTop; 

        // this.throttle("scroll", "optimizedScroll");
        // window.addEventListener("optimizedScroll", this.handleScroll);

        this.observe();
    }

    // isInViewPort() {
    //     const bounding = this.container.getBoundingClientRect()
    //     return bounding.top >= 0;
    // }

    throttle(type, name, obj) {
        obj = obj || window;
        var running = false;
        var func = function() {
            if (running) { return; }
            running = true;
             requestAnimationFrame(function() {
                obj.dispatchEvent(new CustomEvent(name));
                running = false;
            });
        };
        obj.addEventListener(type, func);
    };

    observe() {
        const config = {
            // rootMargin: '0px 0px 50px 0px',
            threshold: 0.5
        };
        
        let observer = new IntersectionObserver(function(entries, self) {
            entries.forEach(entry => {
                if (entry.intersectionRatio > 0) {
                    entry.target.classList.add('parallax--in-viewport');                  
                } else {
                    entry.target.classList.remove('parallax--in-viewport');
                }
            });
        }, config);
    
        observer.observe(this.container);
    }

    handleScroll() {

        if(window.innerWidth < 480) {
            return;
        }

        var fromTop = window.pageYOffset;          
            if(this.background && this.containerFromTop - fromTop > -1050) {
                var newValue = Math.round((fromTop-this.containerFromTop) * -0.15);
                if (newValue > this.maxYShift) {
                    newValue = this.maxYShift;
                }
                this.background.style.transform = `translate3d(0, ${newValue}px, 0)`;
                if(this.overlay) {                    
                    if(this.containerFromTop - fromTop < 0) {
                        this.overlay.style.opacity = 1 - (fromTop - this.containerFromTop) / (this.overlay.offsetHeight - 300);
                    }
                    else {
                        this.overlay.style.opacity = 1 + (fromTop - this.containerFromTop) / (this.overlay.offsetHeight - 300);
                    }
                }
            }
 
            // if(this.containerFromTop - fromTop <= this.container.offsetHeight - 100) {
            //     this.container.classList.add('parallax--in-viewport');
            // }
            // else {
            //     this.container.classList.remove('parallax--in-viewport');
            // }
    }
}

loader.add('Parallax', Parallax);

export default Parallax;